<template>
<v-container fluid :class="{ 'blue': dragover }" 
            @drop.prevent="onDrop($event)"
            @dragover.prevent="dragover = true"
            @dragenter.prevent="dragover = true"
            @dragleave.prevent="dragover = false">
    <v-toolbar class="elevation-0" height="48px">
        <v-toolbar-title >Liste des fichiers</v-toolbar-title>
        <v-icon class="ml-5">mdi-filter</v-icon>
        <v-autocomplete dense clearable class="ml-2 mr-2" v-model="filter.typ_id" :items="getCacheType('DOC')" 
            item-text="typ_name" item-value="typ_id" multiple chips @change="getDocument()" style="max-width: 250px">
            <template v-slot:selection="data">
                <v-chip :input-value="data.selected" @click:close="removeChip('typ_id', data.item.typ_id)" 
                        close small class="chip--select-multi" :color="data.item.typ_color" >
                    {{ data.item.typ_name }}
                </v-chip>
            </template>
            <template slot="item" slot-scope="data">{{ data.item.typ_name }}</template>
        </v-autocomplete>
        <v-btn v-if="enableAdd" class="ml-2"
            :outlined="!(filter.sta_id.indexOf('GEN04') !== -1)" rounded x-small :color="(filter.sta_id.indexOf('GEN04') !== -1) ? 'green' : 'brown'" @click="filterByState('GEN04')">
            Archivés<v-icon>mdi-archive-arrow-down-outline</v-icon>
        </v-btn>
        <v-btn v-if="enableAdd" class="ml-2"
            :outlined="!(filter.sta_id.indexOf('GEN05') !== -1)" rounded x-small :color="(filter.sta_id.indexOf('GEN05') !== -1) ? 'green' : 'grey'" @click="filterByState('GEN05')">
            Supprimé<v-icon>mdi-archive-arrow-down-outline</v-icon>
        </v-btn>    
        <v-spacer></v-spacer>
        <v-btn v-if="enableAdd && isAuthorized( 'document', 'update' )" 
            outlined rounded small :color="(routeState.view) ? 'grey' : 'green'" @click="openDocument(0)" :disabled="!routeState.edit">
            Ajouter<v-icon>mdi-playlist-edit</v-icon>
        </v-btn>
    </v-toolbar>
    <v-data-table v-bind:headers="headers" :items="items" item-key="sta_id"
        items-per-page-text="Lignes par page" :items-per-page-options="pagination.rowsPerItem" :loading="loading.getDocument" multi-sort> 
        <template v-slot:[`item.doc_created_at`]="{ item }">
            <v-chip label outlined :color="(item.doc_sta_id == 'GEN04') ? 'brown' : 'grey'">{{ locDateFormat.formatLocale( item.doc_created_at, 'fr' ) }}</v-chip>
        </template>
        <template v-slot:[`item.doc_name`]="{ item }">
            <span class="d-inline-block text-truncate" style="max-width: 400px;" :style="'color:' + ((item.doc_sta_id == 'GEN04') ? 'brown;' : 'black;')">
            {{ item.doc_name }}
            </span>
        </template>
        <template v-slot:[`item.doc_typ_id`]="{ item }">
            <v-chip label outlined :color="(item.doc_sta_id == 'GEN04') ? 'brown' : 'grey'">{{ typeState[item.doc_typ_id.substring(0, 3)][item.doc_typ_id].typ_name }}</v-chip>
        </template>
        <template v-slot:[`item.doc_filename`]="{ item }">
            <v-icon :color="fileColor[getFileIcon(item.doc_filename)]">mdi-{{ fileIcon[getFileIcon(item.doc_filename)] }}</v-icon>{{ item.doc_filename }}
        </template>
        <template v-slot:[`item.doc_id`]="{ item }">
            <v-icon v-if="!loading.downloadDocument" left color='primary' title="Télécharger" @click="downloadDocument(item.doc_id)">
                mdi-file-download
            </v-icon>
            <v-progress-circular v-else :size="25" :width="3" color="primary" indeterminate class="mr-3"></v-progress-circular>
            <v-icon left color='orange' title="Editer" v-if="isAuthorized( 'Documents', 'update' )" @click="editDocument(item.doc_id)">
                mdi-pencil
            </v-icon>
            <v-icon left color='red' title="Supprimer" v-if="( !item.doc_deleted_at && isAuthorized( 'Documents', 'destroy' ) )" @click="deleteDocument(item.doc_id)">
                mdi-delete-forever
            </v-icon>
            <v-icon left color='green' title="Restaurer" v-if="( ( item.doc_deleted_at || item.doc_sta_id !== 'GEN01' ) && isAuthorized( 'Documents', 'destroy' ) )" @click="restoreDocument(item)">
                mdi-file-restore-outline
            </v-icon>
            <v-icon left color='brown' title="Archiver" v-if="(!item.doc_deleted_at) && (item.doc_sta_id !== 'GEN04') && isAuthorized( 'Documents', 'destroy' ) && (item.doc_sta_id == 'GEN01')" @click="archiveDocument(item.doc_id)">
                mdi-archive-arrow-down-outline
            </v-icon>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        De {{ pageStart }} à {{ pageStop }}
        </template>
        <template slot="no-data">
        <v-alert :value="( !loading.getDocument )" color="info" icon="mdi-information-outline">
            Aucun fichier, ajoutez un nouveau fichier
        </v-alert>
        </template>
    </v-data-table>

    <v-dialog v-model="modalLayer" max-width="900" >
        <!-- <tab-layer v-if="modalLayer" :doc_id="doc_id" :switchModal="switchModal"></tab-layer> -->
    </v-dialog>
    <v-dialog v-model="modalDocument" max-width="900" >
        <v-card color="grey lighten-4" min-width="350px" flat >
        <v-toolbar color="primary" dark class="elevation-1" height="50px">
            <v-btn icon><v-icon>mdi-chevron-down</v-icon></v-btn>
            <v-toolbar-title>Document</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon color="" @click.native="switchModal('modalDocument', 0)"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="mt-2">
            <edit-document class="elevation-2" 
                v-if="modalDocument" :switchModal="switchModal"
                :xxxId="doc_xxx_id" :docId="docInfo.doc_id" :docTable="table_id" :docType="'DOC'" :withFile="uploadedFiles">
            </edit-document>
        </v-card-text>
        </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import dateLocale   from '../services/dateLocale';
import editDocument from '../components/Edit_document.vue'
import { usrGetters }   from "../store/user.module"
import { cacheGetters } from "../store/cache.module"

export default {
    name: 'tab_document',
    props: ['table_id', 'doc_xxx_id', 'routeState', 'totalDoc'],
    data: function () {
      return {
            loading: { uploadBtn: false, getDocument: false, downloadDocument: false },         // Enregistrement en cours...
            dragover: false,
            uploadedFiles: undefined,
            typeState: cacheGetters.getTypes(),
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            headers: [
            { text: 'Nom',  align: 'left', value: 'doc_name'},
            { text: 'Type', align: 'left', value: 'doc_typ_id'},
            { text: 'Date de création',    value: 'doc_created_at', align: 'left'},
            { text: 'Fichier',             value: 'doc_filename', align: 'left'},
            { text: 'Télécharger',         value: 'doc_id', align: 'right' }
            ],
            fileIcon: {
                gen: 'file-document-outline', pdf: 'file-pdf-box', doc: 'file-word-outline', docx: 'file-word-outline',
                xls: 'file-excel-outline', xlsx: 'file-excel-outline', jpg: 'file-image-outline', jpeg: 'file-image-outline',
                zip: 'archive-arrow-down-outline', rar: 'archive-arrow-down-outline', png: 'file-image-outline', svg: 'file-image-outline'
            },
            fileColor: {
                gen: 'primary', pdf: 'red', doc: 'blue', docx: 'blue',
                xls: 'green', xlsx: 'green', jpg: 'amber', jpeg: 'amber', png: 'amber', svg: 'amber',
                zip: 'brown', rar: 'brown'
            },
            items: [],
            locDateFormat: dateLocale,
            enableAdd: true,
            addItem: {
                doc_id: 0 , doc_xxx_id: this.doc_xxx_id, doc_table_id: 0, doc_sta_id: 'GEN01',
                doc_filename: '', doc_name: '', doc_description: '',
                _method: 'POST', _path: 'document'
            },
            modalLayer : false,
            docInfo: { doc_id: 0, doc_sta_id : 'DOC01', doc_table_id: this.table_id, doc_xxx_id  : this.doc_xxx_id },
            modalDocument: false,
            filter: {
                typ_id: [],
                sta_id: ['GEN01']
            },
            isAuthorized: usrGetters.getScopeRight
      }
    },
    mounted: function (){
        this.getDocument()
    },
    methods: {
        getDocument(){
            //this.items = []
            this.loading.getDocument = true
            var searchCriteria = '?per_page=false' //page='+ this.pagination.page +'&
            searchCriteria    += '&doc_xxx_id=' +  this.doc_xxx_id + '&doc_table_id=' + this.table_id
            searchCriteria    += (this.filter.typ_id.length > 0) ? '&doc_typ_id=' + this.filter.typ_id.join(','): ''
            searchCriteria    += '&doc_sta_id=' + this.filter.sta_id.join(',')
            this.$http.get( '/documents/' + searchCriteria ).then( (response) => {
                if( response.data.meta.total !== undefined && response.data.meta.total !== '0' ){
                    this.pagination.totalItems  = parseInt(response.data.meta.total)
                } else {
                    this.pagination.totalItems = 1
                }
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    this.items = response.data.data
                }
                this.$emit('update:totalDoc', this.pagination.totalItems)
                //this.$emit('change', this.totalDoc)

                this.loading.getDocument = false
            })
        },
        addLineFile() {
            this.enableAdd = false
            this.items.push({
                doc_id      : 0,
                doc_filename: '',
                doc_name    : '',
                doc_description: ''
            })
        },
        openDocument(id){
            this.docInfo.doc_id = id
            this.switchModal('modalDocument', 1)
        },
        editDocument(id){
            this.docInfo.doc_id = id
            this.switchModal('modalDocument', 1)
        },
        archiveDocument(docid){
            this.$root.$confirm('Archiver', 'Confirmer l\'archivage de ce document', { color: 'brown', width: 400 }).then((confirm) => {
                if( confirm ){
                    this.$http.put( 'documents/' +  docid, {doc_id: docid, doc_sta_id: 'GEN04'}).then( () => {
                        this.$root.$toast({ color: 'brown', top:false, bottom:true, right:false, left:true, text:'Document archivé !' })
                        this.getDocument()
                    })
                }
            })
        },
        openAssocModal(id){
            if( id !== undefined && id > 0 ){
                this.switchModal('modalLayer', 1)
            }
        },
        deleteDocument( docid ){
            this.$root.$confirm('Supprimer', 'Confirmer la suppression de ce document', { color: 'red', width: 400 }).then((confirm) => {
                if( confirm ){
                    this.$http.delete( 'documents/' +  docid).then( () => {
                        this.$root.$toast({ color: 'error', top:false, bottom:true, right:false, left:true, text:'Document supprimée !' })
                        this.getDocument()
                    })
                }
            })
        },
        restoreDocument(item){
            this.$root.$confirm('Supprimer', 'Confirmer la restauration de ce document', { color: 'red', width: 400 }).then((confirm) => {
                if( confirm ){
                    let restore = ( item.doc_deleted_at ) ? '/restore' : ''
                    this.$http.put( 'documents/' +  item.doc_id + restore, { doc_sta_id: 'GEN01' }).then( () => {
                        this.$root.$toast({ color: 'error', top:false, bottom:true, right:false, left:true, text:'Document restauré !' })
                        this.getDocument()
                    })
                }
            })
        },
        downloadDocument(doc_id){
            this.loading.downloadDocument = true
            this.$http.customRequest({ method: 'get', url: 'documents/' + doc_id + '/download', responseType: 'blob' } )
            .then( (response) => {
                let filename      = 'd.pdf'
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                let matches = filenameRegex.exec(response.headers['content-disposition']);
                if (matches != null && matches[1]) { 
                    filename = matches[1].replace(/['"]/g, '');
                }
                if( response.status == 204 ){
                    this.$root.$toast({ color: 'warning', text: 'Ce fichier n\'existe pas' })
                } else {
                    this.$download(response.data, filename, response.headers['content-type'])
                }
                this.loading.downloadDocument = false
            }).catch( (error) => {
                this.$root.$toast({ color: 'error', text: error })
                this.loading.downloadDocument = false
            })
        },
        switchModal(name, mode, refresh){
            name    = name || 'modalDocument'
            mode    = mode || 0
            refresh = refresh || false
            this[name] = mode
            if( mode == 0 ){
                this.uploadedFiles = undefined
                //this.doc_xxx_id = 0
            }
            if( refresh ){
                this.getDocument()
            }
        },
        onDrop(e) {
            if( !this.isAuthorized( 'Documents', 'update' ) ){
                this.dragover = false;
                return true
            }
            this.dragover = false;
            if (e.dataTransfer.files.length > 0) {
                this.uploadedFiles = Array.from(e.dataTransfer.files)
                this.openDocument(0)
                //this.$root.$toast({ color: 'error', text: 'Un seul fichier à la fois.' })
            } else { // useless toDoo : delete
                e.dataTransfer.files.forEach(element =>
                    this.uploadedFiles = element
                )
                this.openDocument(0)
            }
        },
        getFileIcon(filename){
            let ext = filename.split('.').pop();
            if( this.fileIcon[ext] ){
                return ext
            } else {
                return 'gen'
            }
        },
        removeChip (fromFilter, id) {
            const index = this.filter[fromFilter].indexOf(id)
            if (index >= 0) this.filter[fromFilter].splice(index, 1)
        },
        filterByState(item){
            this.filter.sta_id.indexOf(item) === -1 ? this.filter.sta_id.push(item) : this.filter.sta_id.splice(this.filter.sta_id.indexOf(item), 1);
            this.getDocument()
        },
        getCacheType   : cacheGetters.getTypes,
        getCacheStates : cacheGetters.getStates,
    },
    components: {
        'edit-document'   : editDocument
    }
}
</script>